import React, { useEffect, useState } from 'react';
import logo from '../assets/LED-Speed-Signs-Logo.png';
import './SplashScreen.css';

// Shown once on initial site load: logo + a thin flowing rainbow line. It fades
// itself out and unmounts after a short delay.
const SplashScreen = () => {
  const [hiding, setHiding] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setHiding(true), 1700); // begin fade-out
    const doneTimer = setTimeout(() => setDone(true), 2250); // unmount after fade
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, []);

  if (done) return null;

  return (
    <div className={`splash-screen ${hiding ? 'is-hiding' : ''}`} aria-hidden="true">
      <img src={logo} alt="LED Speed Signs" className="splash-logo" />
      <div className="splash-bar" />
    </div>
  );
};

export default SplashScreen;
